<template>
  <v-data-table
    :items="getAutomaticPreparationSlipTemplates"
    :headers="getHeaders"
    sort-by="created"
    :sort-desc="true"
    :loading="loading"
    :mobile-breakpoint="0"
    :hide-default-header="$vuetify.breakpoint.xsOnly || dense"
    :dense="dense"
    hide-default-footer
    :items-per-page="
      dense
        ? getAutomaticPreparationSlipTemplates.length + 1
        : $vuetify.breakpoint.xsOnly
        ? 5
        : 10
    "
    :search="search"
    @page-count="pageCount = $event"
    :page.sync="page"
  >
    <template v-slot:item.mobile="{ item }">
      <v-row no-gutters class="mt-1">
        <span class="caption">Créé le {{ item.display_created }}</span>
      </v-row>
      <v-row no-gutters>
        <span class="font-weight-bold"> {{ getProductName(item) }}</span>
      </v-row>
      <v-row no-gutters>
        <span> {{ item.display_day }}</span>
      </v-row>
      <v-row align="end" no-gutters class="mb-1">
        <span>{{ item.quantity }}</span>
        <span class="caption ml-1">{{ getProductUnit(item) }}</span>
      </v-row>
    </template>
    <template v-slot:item.fk_product="{ item }">
      {{ getProductName(item) }}
    </template>
    <template v-slot:item.quantity="{ item }">
      <span>{{ item.quantity }}</span>
      <span class="caption ml-1">{{ getProductUnit(item) }}</span>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <AutomaticPrepSlipEditor
          :id="item.id"
          @update="$emit('update')"
        ></AutomaticPrepSlipEditor>
      </v-row>
    </template>
    <template v-slot:top v-if="!dense">
      <v-row align="center" justify="end" dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer v-if="!dense">
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import AutomaticPrepSlipEditor from "./AutomaticPrepSlipEditor";
export default {
  name: "AutomaticPrepSlipGrid",
  components: {
    AutomaticPrepSlipEditor
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      "getAutomaticPreparationSlipTemplates",
      "getIsAdmin",
      "getProducts"
    ]),
    getHeaders() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          { value: "mobile", text: "" },
          { value: "actions", text: "" }
        ];
      } else if (this.dense) {
        return [
          { value: "fk_product", text: "Produit" },
          { value: "display_day", text: "Journée" },
          { value: "quantity", text: "Quantité" }
        ];
      } else {
        return [
          { value: "display_created", text: "Date de création" },
          { value: "fk_product", text: "Produit" },
          { value: "display_day", text: "Journée" },
          { value: "quantity", text: "Quantité" },
          { value: "actions", text: "" }
        ];
      }
    }
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      search: ""
    };
  },
  methods: {
    getProductName(item) {
      const p = this.getProducts.find(x => x.id === item.fk_product);
      return p ? p.nom : "";
    },
    getProductUnit(item) {
      const p = this.getProducts.find(x => x.id === item.fk_product);
      return p && p.data ? p.data.unite_mesure_inventory : "";
    }
  }
};
</script>

<style></style>
